export function useUserAvatarBackgroundColor() {
  const getUserAvatarBackgroundColor = (name) => {
    const hash = getHashOfString(name)
    const h = normalizeHash(hash, 0, 360)
    const s = normalizeHash(hash, 50, 75)
    const l = normalizeHash(hash, 25, 60)

    return `hsl(${h}, ${s}%, ${l}%)`
  }

  return {
    getUserAvatarBackgroundColor,
  }
}

function getHashOfString(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  hash = Math.abs(hash)
  return hash
}

function normalizeHash(hash, min, max) {
  return Math.floor((hash % (max - min)) + min)
}
